import React from "react";

import { isNoticesReady } from "state/teachers/selectors";

import MaintainValidSchoolID from "components/teachers/MaintainValidSchoolID";
import Preloader from "components/teachers/Preloader";
import SchoolSelector from "components/teachers/SchoolSelector";
import SchoolCarousel from "components/teachers/SchoolCarousel";
import SchoolNoticeList from "components/teachers/noticeboard/SchoolNoticeList";

import "./NoticeboardPage.css";

export default class NoticeboardPage extends React.Component {
  
  isNoticesReady = (state) => {
    return isNoticesReady(state, this.props.schoolID);
  }
  
  generatePath = (schoolID) => {
    return `/teachers/noticeboard/${schoolID}/`;
  }
  
  render() {
    const { schoolID } = this.props.match.params;
    return (
      <MaintainValidSchoolID currentSchoolID={schoolID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isNoticesReady}>
          <div className="noticeboard-page">
            <div className="page-header">
              <h1 className="page-header__title">Noticeboard</h1>
              <SchoolSelector selectedSchoolID={schoolID} generatePath={this.generatePath} />
            </div>
            <SchoolCarousel activeSchoolID={schoolID} generatePath={this.generatePath}>
              { schoolID => <SchoolNoticeList key={schoolID} schoolID={schoolID} /> }
            </SchoolCarousel>
          </div>
        </Preloader>
      </MaintainValidSchoolID>
    );

  }
};



// WEBPACK FOOTER //
// ./src/components/teachers/noticeboard/NoticeboardPage.js